import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const IMPORT_PRODUCT_MASTER_DATA = '/api/bc/import/product_master_data';
const IMPORT_PURCHASE_ORDERS = '/api/bc/import/purchase_orders';
const IMPORT_STOCK_LOCATIONS = '/api/bc/import/stock_locations';

export namespace BusinessCentralRequest {
  export const importProductMasterData = async (payload: { settingId: string }): Promise<PaginatedResponse<void>> => {
    return (await http.post(IMPORT_PRODUCT_MASTER_DATA, payload)).data;
  };

  export const importPurchaseOrders = async (payload: { settingId: string }): Promise<PaginatedResponse<void>> => {
    return (await http.post(IMPORT_PURCHASE_ORDERS, payload)).data;
  };

  export const importStockLocations = async (payload: { settingId: string }): Promise<PaginatedResponse<void>> => {
    return (await http.post(IMPORT_STOCK_LOCATIONS, payload)).data;
  };
}
